import { additionalElectricTrendLines } from "../../constants/trendGraph/additionalElectricTrend";
import { groupeElectricTrendLine } from "../../constants/trendGraph/electricLines";
import { GRAPH_TYPE } from "../../constants/trendGraph/trendGraphType";
import _ from 'lodash'

const setHideLine = (state, action) => {
  state.hideLists = [...new Set(state.hideLists.concat([action.payload]))];
};

const removeHideLine = (state, action) => {
  state.hideLists = state.hideLists.filter((d) => d !== action.payload);
};

const removeAllHideLine = (state, _) => {
  state.hideLists = [];
};

const setChartList = (state, action) => {
  state.chartList = action.payload;
};

const changeColor = (state, action) => {
  switch (action.payload.graphType) {
    case GRAPH_TYPE.ENGINE:
      state.engineChartList.find(
        (d) => d.keyName === action.payload.dataKey && d.chartType === action.payload.chartType
      ).color = action.payload.color;
      break;
    case GRAPH_TYPE.SEP:
      state.sepChartList.find((d) => d.keyName === action.payload.dataKey).color =
        action.payload.color;
      break;
    case GRAPH_TYPE.ELECTRIC:
      state.electricChartList.find((d) => d.keyName === action.payload.dataKey).color =
        action.payload.color;
      break;
    case GRAPH_TYPE.EMISSION_LINES:
      state.emissionChartLineList.find((d) => d.keyName === action.payload.dataKey).color =
        action.payload.color;
      break;
    case GRAPH_TYPE.EMISSION_BARS:
      state.emissionChartBarList.find((d) => d.keyName === action.payload.dataKey).color =
        action.payload.color;
      break;
  }
};

const updateChartLineName = (state, action) => {
  // custom dashboard need to access multiple charts lines data
  const newChartLine = [];
  // for no common name Vessels
  if(!action.payload?.commonNames){
    state.electricChartList = {...state.electricChartList, ...groupeElectricTrendLine};
    return;
  }

  // for using common name
  action.payload.commonNames.forEach((e, i) => {
    const chartLine = additionalElectricTrendLines.find((line) => line.key === e);
    if(chartLine) {
      newChartLine.push({
        ...chartLine,
        name: action.payload.chName[i],
        displayName: action.payload.chName[i],
      })
    }
  })
  const groupedNewChartLine = _.groupBy(newChartLine, line => line.chartType);
  state.electricChartList = {...state.electricChartList, ...groupedNewChartLine};
}

export default {
  setHideLine,
  removeHideLine,
  removeAllHideLine,
  setChartList,
  changeColor,
  updateChartLineName,
};
